import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

export const updateCourt = async (data) => {
  const { courtId, ...rest } = data
  const url = `v1/orgs/${selectedOrgId()}/courts/${courtId}`

  const response = await axiosInstance.patch(url, JSON.stringify({ ...rest }))

  return response.data
}
